'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_Component) {
	_inherits(Checkbox, _Component);

	function Checkbox(props) {
		_classCallCheck(this, Checkbox);

		return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));
	}

	_createClass(Checkbox, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    wrapperClass = _props.wrapperClass,
			    label = _props.label,
			    onChange = _props.onChange,
			    rest = _objectWithoutProperties(_props, ['wrapperClass', 'label', 'onChange']);

			var id = _underscore2.default.uniqueId('checkbox_');
			var checked = this.props.checked || false;
			return _react2.default.createElement(
				'div',
				{ className: "input-wrapper checkbox-wrapper " + wrapperClass },
				_react2.default.createElement('input', {
					type: 'checkbox',
					onChange: onChange,
					checked: checked,
					id: id
				}),
				_react2.default.createElement('div', { className: (0, _classnames2.default)("checkbox", { checked: checked }), onClick: this.handleClick.bind(this) }),
				_react2.default.createElement(
					'label',
					{ htmlFor: id },
					label
				)
			);
		}
	}, {
		key: 'handleClick',
		value: function handleClick() {

			var checked = this.props.checked || false;

			var e = {
				target: {
					type: 'checkbox',
					checked: !checked
				}
			};

			this.props.onChange(e);
		}
	}]);

	return Checkbox;
}(_react.Component);

exports.default = Checkbox;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/form/Checkbox.js
// module id = 566
// module chunks = 0